import { Providers } from "components/Condominiums/Providers";

export const ListProviders = () => {
  return (
    <Providers />
  );
};
